import React from 'react';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Chip,
  Stack,
  Divider
} from '@mui/material';

const PRICING_TYPES = [
  {
    title: 'Listed Price',
    accent: '#2e7d32',
    audiences: ['New consumers', 'Current Consumers'],
    examples: ['Device listed price', 'Pack listed price']
  },
  {
    title: 'Registration Offer',
    accent: '#2e7d32',
    audiences: ['New consumers'],
    examples: ['Starter kit offer', 'Device voucher']
  },
  {
    title: 'Flash Promo',
    accent: '#2e7d32',
    audiences: [
      'New consumers - Registration offer',
      'Current consumers'
    ],
    examples: ['Black Friday device deal', 'Bundle limited-time offer', 'Seasonal promo']
  }
];

const PricingTypesView = () => {
  return (
    <Box sx={{ padding: '24px 32px 40px' }}>
      <Box sx={{ marginBottom: 3 }}>
        <Typography variant="h4" sx={{ fontWeight: 700, marginBottom: 1 }}>
          Pricing Types Definitions
        </Typography>
        <Typography variant="body1" sx={{ color: '#555', maxWidth: 900 }}>
          HQ overview of pricing mechanics and target consumer segments across listed prices,
          registration offers, and flash promotions.
        </Typography>
      </Box>

      <Grid container spacing={2}>
        {PRICING_TYPES.map((type) => (
          <Grid item xs={12} md={4} key={type.title}>
            <Card elevation={0} sx={{ borderRadius: 2, border: '1px solid #e0e0e0' }}>
              <CardContent>
                <Box
                  sx={{
                    backgroundColor: type.accent,
                    color: '#fff',
                    borderRadius: 1,
                    padding: '6px 12px',
                    display: 'inline-flex',
                    alignItems: 'center',
                    marginBottom: 2
                  }}
                >
                  <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                    {type.title}
                  </Typography>
                </Box>

                <Typography variant="subtitle2" sx={{ fontWeight: 700, marginBottom: 1 }}>
                  Target segments
                </Typography>
                <Stack spacing={1} sx={{ marginBottom: 2 }}>
                  {type.audiences.map((audience) => (
                    <Chip
                      key={audience}
                      label={audience}
                      size="small"
                      sx={{ justifyContent: 'flex-start', fontWeight: 600 }}
                    />
                  ))}
                </Stack>

                <Divider sx={{ marginBottom: 2 }} />

                <Typography variant="subtitle2" sx={{ fontWeight: 700, marginBottom: 1 }}>
                  Examples
                </Typography>
                <Stack spacing={0.5}>
                  {type.examples.map((example) => (
                    <Typography key={example} variant="body2" sx={{ color: '#555' }}>
                      • {example}
                    </Typography>
                  ))}
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      
    </Box>
  );
};

export default PricingTypesView;
